module.exports = __webpack_public_path__ + "static/wave-pattern-5db6831b3387314ec40bac006ce4a898.svg";